export default __webpack_public_path__ + "static/media/avatar_ali6.ae4dd5a9.mp3";